import { render, staticRenderFns } from "./Anamnesis.vue?vue&type=template&id=3c6360c5&lang=pug&"
import script from "./Anamnesis.vue?vue&type=script&lang=js&"
export * from "./Anamnesis.vue?vue&type=script&lang=js&"
import style0 from "./Anamnesis.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports